import { useEffect } from 'react'

import styles from './AreaPage.module.scss'

import { useInitMileageClerkSession } from '@/pages/Dashboard'
import { useDateStore } from '@/components/DateInput'
import { isToday } from 'date-fns'
import { AreasView } from '@/modules/AreasView'
import { AreasViewHistory } from '@/modules/AreasViewHistory'
import { AreasSelect } from '@/modules/Areas'

export const AreasPage = () => {
    const init = useInitMileageClerkSession()
    const { date } = useDateStore()
    const isTodaySelected = isToday(date)

    useEffect(() => {
        init()
    }, [])

    return (
        <section className={styles.root}>
            <div className={styles.header}>
                <AreasSelect />
            </div>

            {isTodaySelected ? <AreasView /> : <AreasViewHistory />}
        </section>
    )
}